import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import ProductListItem from '../../components/ProductListItem';
import { makeRequest, Loading } from '../../Utils';
import { useRecoilValue } from 'recoil';
import { sessionState } from '../../atoms';
import GhostGrid from '../../components/GhostGrid';

export default function BooksAll() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState('');
  const session = useRecoilValue(sessionState);
  const [page, setPage] = useState(0);

  document.title = 'Search Results | Asterism Books';
  document.querySelector('meta[name="description"]').setAttribute('content', 'Search results.');

  const location = useLocation();

  const search = async (query) => {
    if (!query) {
      return;
    }
    setLoading(true);
    if (page === 0) {
      setProducts([]);
    }
    let data = await makeRequest(`search?term=${query}&page=${page}`);
    setProducts(page === 0 ? data : products.concat(data));
    setLoading(false);
  }

  useEffect(() => {
    setLoading(true);
    let params = new URLSearchParams(window.location.search);
    let searchQuery = params.get('query');
    if (searchQuery) {
      setQuery(searchQuery);
    } else {
      setLoading(false)
    }
  }, [location]);

  useEffect(() => {
    if (query) {
      search(query);
      document.title = `Search | Asterism Books`;
      document.querySelector('meta[name="description"]').setAttribute('content', `Search results from Asterism Books`);
    }
  }, [query, page])


  return (
    <div>
      <div className='flex-layout'>
        <h1 className='page-header'>{loading ? `Searching for "${query}"` : `Search results for "${query}"`}</h1>
      </div>


      <div className='lowerGrid'>

        {products.map((product) =>
          <ProductListItem key={product._id} product={product} context={'search'} />
        )}
        {loading && <GhostGrid />}
      </div>
      {!loading && products.length === 0 && <div>No Results</div>}
      <button className='loadMore' disabled={products.length % 20 !== 0} onClick={() => { setPage(page + 1) }}>Load More Results</button>

    </div>
  )
}
